import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';

interface Props {
    showBackButton?: boolean,
    size?: 's' | 'l',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractAddressesSubMenu',
  props: {
    showBackButton: { type: Boolean, default: true },
    size: { default: 'l' }
  },
  emits: ['back'],
  setup(__props: any) {

const props = __props as { showBackButton: boolean, size: 's' | 'l' };





const {
    showBackButton,
    size,
} = toRefs(props);


return { __sfc: true,props, showBackButton, size }
}

})